import { EmailValidator, checkSafely, isAllNumber, oldPassword, newPassword, newPassword2, newSafePassword, newSafePassword2 } from "./validation";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  //邮箱规则验证
  email: [{ required: true, validator: EmailValidator }],
  //密码规则验证
  safePwd: [{ required: true, validator: checkSafely }],
  mobile: [{ required: true, validator: isAllNumber }],
  oldPassword: [{ required: true, validator: oldPassword }],
  newPassword: [{ required: true, validator: newPassword }],
  newPassword2: [{ required: true }, newPassword2],
  newSafePassword: [{ required: true, validator: newSafePassword }],
  newSafePassword2: [{ required: true }, newSafePassword2],
  emailCode: [{ required: true, message: " ", pattern: /^[0-9]{6}$/ }],
  newEmailCode: [{ required: true, message: " ", pattern: /^[0-9]{6}$/ }],
  verifyCode: [{ required: true, message: " ", pattern: /^[0-9]{6}$/ }],
  mobileCode: [{ required: true, message: " ", pattern: /^[0-9]{6}$/ }],
  newMobileCode: [{ required: true, message: " ", pattern: /^[0-9]{6}$/ }],
  googleCode: [{ required: true, message: " ", pattern: /^[0-9]{6}$/ }],
  subCode: [{ required: true, message: " ", pattern: /^[0-9]{6}$/ }],
  antiFishingCode: [{ required: true, message: " ", pattern: /^[1-9a-z]\w{3,19}$/i }],
};
